import { useState } from 'react';
import {
  downloadOfflineRecovery,
  recoveryText,
} from '../../utils/mindmap/offlineRecovery';

export default function OfflineRecoveryDialog({ record, onReload, onDismiss }) {
  const [copyStatus, setCopyStatus] = useState(null);
  if (!record) return null;
  const accessRejected = record.kind === 'access-rejected';
  const conflictCount = record.conflicts?.length || 0;

  const copyText = async () => {
    const text = recoveryText(record);
    if (!text) {
      setCopyStatus('There is no text to copy from this recovery.');
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
      setCopyStatus('Recovery text copied.');
    } catch {
      setCopyStatus('Copy was blocked by the browser. Download the JSON recovery instead.');
    }
  };

  return (
    <div
      className="offline-recovery-backdrop"
      role="presentation"
      data-export-ignore="true"
    >
      <section
        className="offline-recovery-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="offline-recovery-title"
      >
        <div className="offline-recovery-dialog__symbol" aria-hidden="true">↺</div>
        <h2 id="offline-recovery-title">
          {accessRejected ? 'Your access to this map changed' : 'One of your offline edits needs review'}
        </h2>
        <p>
          {accessRejected
            ? 'Mindmappi stopped syncing before accepting more changes. Your local map has been preserved as a recovery copy on this device.'
            : `${conflictCount} local node ${conflictCount === 1 ? 'version was' : 'versions were'} replaced when collaborators’ changes converged. The accepted map is safe, and your wording is preserved below.`}
        </p>
        {record.storageEligible === false && (
          <p className="offline-recovery-dialog__warning">
            This map is too large for the bounded recovery store. Download it before leaving this page.
          </p>
        )}
        {copyStatus && <p role="status">{copyStatus}</p>}
        <div className="offline-recovery-dialog__actions">
          <button type="button" onClick={() => downloadOfflineRecovery(record)}>
            Download recovery JSON
          </button>
          <button type="button" onClick={copyText}>
            Copy recovered text
          </button>
          {accessRejected ? (
            <button
              type="button"
              className="offline-recovery-dialog__secondary"
              onClick={() => {
                downloadOfflineRecovery(record);
                onReload?.();
              }}
            >
              Download recovery and reload
            </button>
          ) : (
            <button type="button" className="offline-recovery-dialog__secondary" onClick={onDismiss}>
              Continue with accepted map
            </button>
          )}
        </div>
      </section>
    </div>
  );
}
